<script>
import { reportListMethod } from '@state/helpers'
import { ErrorWrapper } from '@utils/error-handler'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      description: '',
      error: null,
      reportRequest: false,
      isChangeError: false,
      isSuccess: false,
      successMessage: null,
      prevent: null,
      isReportError: false,
      reportError: false,
      reportSuccess: '',
      isLoading: false,
    }
  },
  computed: {},
  methods: {
    ...reportListMethod,
    requestReport() {
      let self = this
      self.isLoading = true
      const report = {
        title: self.data.title,
        description: self.data.description,
        id: self.data._id,
      }

      this.updateReportRequest({ report })
        .then((reportrequest) => {
          self.isLoading = false
          this.title = ''
          this.description = ''
          this.reportSuccess = 'Report Updated Successfully'
          this.isSuccess = true
          window.location.reload()
        })
        .catch((error) => {
          self.isLoading = false
          this.title = ''
          this.description = ''
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.reportError = getError.message
          this.isReportError = true
        })
    },
    resetModal() {
      this.title = ''
      this.description = ''
      this.reportSuccess = ''
      this.isSuccess = false
      this.isReportError = false
      this.reportError = ''
    },
  },
}
</script>
<template>
  <b-modal
    id="my-modal1"
    title="Update Report Title and Description"
    :hide-footer="true"
    @hidden="resetModal"
  >
    <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
      <b-form @submit.prevent="requestReport">
        <b-alert
          v-model="isReportError"
          variant="danger"
          v-html="reportError"
        ></b-alert>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="reportSuccess"
        ></b-alert>
        <b-form-group label="Report Title" label-for="title">
          <b-form-input
            id="title"
            v-model="data.title"
            type="text"
            required
            placeholder="Add Report Title"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Report Description" label-for="description">
          <b-form-input
            id="description"
            v-model="data.description"
            type="text"
            required
            placeholder="Add Report Description"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="button-group" class="mt-2">
          <b-button type="submit" variant="primary" class="btn-block button"
            >Save</b-button
          >
        </b-form-group>
      </b-form>
    </b-overlay>
  </b-modal>
</template>
<style>
.button {
  width: 100px;
  background-color: skyblue;
}
.modal-backdrop {
  opacity: 0.5;
}
</style>
